import React, { ClipboardEvent, useCallback } from 'react';
import { useTranslator } from '../../../i18n/useTranslator';
import { Popover } from '@milanote/roma';
import { cx } from '@milanote/roma/utils';

const styles = {
    sm: {
        inputSize: 'md',
    },
    lg: {
        inputSize: 'lg',
    },
} as const;

type BoardLinkSearchBarProps = {
    value: string;
    onChange: (value: string) => void;
    onPasteBoardLink?: (text: string) => boolean;
    autoFocus: boolean;
    className?: string;
    size?: keyof typeof styles;
};

const BoardLinkSearchBar: React.FC<BoardLinkSearchBarProps> = ({
    value,
    onChange,
    onPasteBoardLink,
    autoFocus,
    className,
    size = 'sm',
}) => {
    const translate = useTranslator('popup', 'boardLink.search');
    const sizeStyles = styles[size];

    const handlePaste = useCallback(
        (event: ClipboardEvent<HTMLInputElement>) => {
            if (!onPasteBoardLink) return;

            const pastedText = event.clipboardData.getData('text/plain');
            if (!pastedText) return;

            const didHandleBoardLink = onPasteBoardLink(pastedText);
            if (!didHandleBoardLink) return;

            event.preventDefault();
        },
        [onPasteBoardLink],
    );

    return (
        <Popover.Header className={cx('BoardLinkSearchBar border-b-0 pb-0', className)}>
            <Popover.Search
                aria-label={translate('placeholder')}
                containerClassName="mn-board-link-query"
                placeholder={translate('placeholder')}
                size={sizeStyles.inputSize}
                value={value}
                onChange={onChange}
                onPaste={handlePaste}
                autoFocus={autoFocus}
            />
        </Popover.Header>
    );
};

export default BoardLinkSearchBar;
